import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setSections } from './sections.actions';
export const sections = createReducer([], on(setSections, (state, action) => {
    return action.sections;
}), on(resetAllCustomPdfReportItems, () => {
    return [];
}));
